
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/heritagetradeprizedraw",
      function () {
        return require("private-next-pages/en/heritagetradeprizedraw/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/heritagetradeprizedraw"])
      });
    }
  